import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Header />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#1B3A5F] mb-4">Privacy Policy</h1>
          <p className="text-slate-600">Effective Date: January 1, 2025</p>
        </div>

        <div className="legal-content prose prose-slate max-w-none">
          <p>
            Auto Accident Claim Assist ("we," "our," or "us") values your privacy. This Privacy Policy explains 
            how we collect, use, disclose, and protect your information when you visit our website, submit a form, 
            contact us for a case review, or communicate with us, including by SMS.
          </p>
          <p>
            By using our website or services, you consent to the practices described in this Privacy Policy.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We may collect the following information:</p>
          
          <h3>Personal Information</h3>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Mailing address</li>
            <li>Details about your auto accident</li>
            <li>Case type and preferences</li>
            <li>Insurance information, where applicable</li>
            <li>Records of consent and opt-in actions for SMS and email communications</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Website usage data</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Process and review your case inquiry</li>
            <li>Connect you with appropriate legal resources</li>
            <li>Send case updates and follow-up communications</li>
            <li>Send appointment reminders and scheduling updates</li>
            <li>Respond to inquiries and support requests</li>
            <li>Improve our website and services</li>
            <li>Maintain records of communication preferences and consent</li>
            <li>Comply with legal and regulatory requirements</li>
          </ul>

          <h2>3. SMS Messaging</h2>
          <p>
            If you opt in to receive text messages from Auto Accident Claim Assist, you may receive SMS messages related to:
          </p>
          <ul>
            <li>Case follow-ups and status updates</li>
            <li>Intake updates</li>
            <li>Appointment scheduling and reminders</li>
            <li>Claim-related notifications</li>
            <li>Service-related follow-ups</li>
            <li>Customer support communications</li>
            <li>Marketing messages about special offers and service updates (only if you separately consent)</li>
          </ul>
          <p>Message frequency may vary. Message and data rates may apply.</p>
          <p>
            You can opt out at any time by replying STOP to any message. For help, reply HELP or contact us at 
            brendan@autoaccidentclaimassist.com or +1 803-403-0488.
          </p>
          <p>
            We only send SMS messages to individuals who have provided consent to receive them. We maintain records 
            of opt-in actions and consent where required.
          </p>

          <h2>4. Mobile Information Sharing</h2>
          <p className="font-semibold bg-slate-100 p-4 rounded-lg">
            No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. 
            Information sharing to subcontractors in support services, such as customer service, is permitted. 
            All other use case categories exclude text messaging originator opt-in data and consent; this information 
            will not be shared with any third parties.
          </p>

          <h2>5. Information Sharing and Disclosure</h2>
          <p>We do not sell, rent, or trade your personal information.</p>
          <p>We may share your information only as necessary with:</p>
          <ul>
            <li>Service providers that help us operate our business, such as scheduling platforms, communication platforms, and SMS providers</li>
            <li>Legal professionals and attorneys as part of your case review process</li>
            <li>Legal or regulatory authorities when required by law</li>
            <li>Successors in the event of a merger, acquisition, or transfer of assets</li>
          </ul>

          <h2>6. Data Security</h2>
          <p>
            We use reasonable administrative, technical, and physical safeguards to protect your information from 
            unauthorized access, use, or disclosure. However, no method of transmission over the internet or storage 
            system is completely secure, and we cannot guarantee absolute security.
          </p>

          <h2>7. Cookies and Tracking Technologies</h2>
          <p>
            Our website may use cookies and similar technologies to improve functionality, understand site usage, 
            and enhance user experience. You can manage cookie preferences through your browser settings.
          </p>

          <h2>8. Your Rights and Choices</h2>
          <p>You may have the right to:</p>
          <ul>
            <li>Access or correct your personal information</li>
            <li>Request deletion of your information, subject to legal requirements</li>
            <li>Withdraw consent for marketing communications</li>
            <li>Opt out of SMS messages by replying STOP</li>
            <li>Contact us with questions about how your information is used</li>
          </ul>

          <h2>9. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the privacy practices 
            of those websites.
          </p>

          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any updates will be posted on this page with a 
            revised effective date.
          </p>

          <h2>11. Contact Us</h2>
          <p><strong>Auto Accident Claim Assist</strong></p>
          <p>South Carolina</p>
          <p>Email: brendan@autoaccidentclaimassist.com</p>
          <p>Phone: +1 803-403-0488</p>
          <p>Website: <a href="https://autoaccidentclaimassist.com" className="text-[#1B3A5F] hover:underline" target="_blank" rel="noopener noreferrer">autoaccidentclaimassist.com</a></p>

          <div className="mt-8 pt-8 border-t border-slate-200">
            <h3>Related Documents</h3>
            <ul>
              <li>
                <Link to="/terms-and-conditions" className="text-[#1B3A5F] hover:underline" data-testid="privacy-terms-link">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <a href="https://autoaccidentclaimassist.com" className="text-[#1B3A5F] hover:underline" target="_blank" rel="noopener noreferrer">
                  Main Website
                </a>
              </li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
